import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

// Lazy-load secondary routes to keep initial JS bundle small (improves LCP/TBT)
const Auth = lazy(() => import("./pages/Auth"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const NHSServiceDetail = lazy(() => import("./pages/NHSServiceDetail"));
const TravelClinic = lazy(() => import("./pages/TravelClinic"));
const VaccinePage = lazy(() => import("./pages/VaccinePage"));
const DestinationPage = lazy(() => import("./pages/DestinationPage"));
const BloodTests = lazy(() => import("./pages/BloodTests"));
const BloodTestProfile = lazy(() => import("./pages/BloodTestProfile"));
const MinorAilmentsHub = lazy(() => import("./pages/MinorAilmentsHub"));
const MinorAilmentDetail = lazy(() => import("./pages/MinorAilmentDetail"));
const BookNow = lazy(() => import("./pages/BookNow"));
const WeightLossHub = lazy(() => import("./pages/WeightLossHub"));
const MounjaroWeightLoss = lazy(() => import("./pages/MounjaroWeightLoss"));
const AdminBookingLinks = lazy(() => import("./pages/AdminBookingLinks"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/book-now" element={<BookNow />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/nhs-services/:serviceId" element={<NHSServiceDetail />} />
            <Route path="/nhs-minor-ailments-hull" element={<MinorAilmentsHub />} />
            <Route path="/nhs-minor-ailments/:ailmentId" element={<MinorAilmentDetail />} />
            <Route path="/travel-clinic" element={<TravelClinic />} />
            <Route path="/travel-clinic/vaccines/:vaccineId" element={<VaccinePage />} />
            <Route path="/travel-clinic/destinations/:destinationId" element={<DestinationPage />} />
            <Route path="/private-blood-tests" element={<BloodTests />} />
            <Route path="/private-blood-tests/profiles/:profileId" element={<BloodTestProfile />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/weight-loss-hull" element={<WeightLossHub />} />
            <Route path="/mounjaro-weight-loss" element={<MounjaroWeightLoss />} />
            <Route path="/admin/booking-links" element={<AdminBookingLinks />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
